import { render, staticRenderFns } from "./AdblockPrompt.vue?vue&type=template&id=3c542f14&scoped=true&"
import script from "./AdblockPrompt.vue?vue&type=script&lang=js&"
export * from "./AdblockPrompt.vue?vue&type=script&lang=js&"
import style0 from "./AdblockPrompt.vue?vue&type=style&index=0&id=3c542f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c542f14",
  null
  
)

/* custom blocks */
import block0 from "./AdblockPrompt.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports